'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageFeedIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var MessageFeedIcon = function MessageFeedIcon(_ref) {
  var color = _ref.color,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? 'transparent' : _ref$fillColor,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'fillColor', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 24 24',
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement('path', {
    fill: fillColor,
    d: 'M2.826 12h4.275v9.229H2.826z'
  }), _react2.default.createElement('path', {
    fill: fillColor,
    d: 'M5.973 2.818h15.434v18.411H5.973z'
  }), _react2.default.createElement('path', {
    fill: color,
    d: 'M17.703 14.008c.438 0 .793.336.793.75s-.355.75-.793.75H10.29c-.438 0-.793-.336-.793-.75s.355-.75.793-.75h7.414zm-7.557-4h7.7c.358 0 .65.336.65.75 0 .38-.245.694-.563.743l-.088.007h-7.699c-.359 0-.65-.336-.65-.75 0-.379.244-.693.562-.743l.088-.007h7.7-7.7zm-.05-4h2.8c.331 0 .6.336.6.75 0 .377-.222.689-.51.742l-.09.008h-2.8c-.332 0-.6-.336-.6-.75 0-.376.221-.688.51-.742l.09-.008h2.8-2.8zm-4.487 6.604H3.28v7.224c0 .599.417.988 1.052 1.038a.715.715 0 0 1 .082-.004h.208c.604-.068.987-.441.987-1.034v-7.224zm-.908 9.758c-1.554.131-2.92-.887-2.92-2.534v-7.974a.75.75 0 0 1 .75-.75h3.078V2.5a.75.75 0 0 1 .75-.75h15.296a.75.75 0 0 1 .75.75v16.783c.081 1.932-.818 3.087-2.546 3.087H4.79c-.068.002-.069.001-.088 0zm2.408-2.534v1.034h12.75c.797 0 1.095-.382 1.046-1.555V3.25H7.11v16.586z'
  }));
};

exports.MessageFeedIcon = MessageFeedIcon;